// shared/constants.js
/**
 * Shared Constants for CATSINO Hub
 * 
 * CRITICAL: This is the single source of truth for game physics.
 * Any calibration changes here will automatically propagate to:
 * - Player clients (speed calculation, contribution meter)
 * - Server (tank dynamics, energy physics)
 * - External bridges (OSC, TouchDesigner, JUCE)
 */

export const ENERGY_PHYSICS = {
    // ===== PLAYER: Speed Calculation =====
    // Lower value = easier to reach max speed with normal scrolling
    SPEED_CALIBRATION_FACTOR: 0.12,

    // ===== PLAYER: Contribution Meter =====
    // How fast the personal energy bar fills when scrolling
    CONTRIBUTION_GAIN: 0.08,
    // Decay rate per frame (0.97 = gentle 3-second fade)
    CONTRIBUTION_DECAY: 0.97,

    // ===== SERVER: Tank Dynamics =====
    // Base leak rate per 100ms tick (static drain)
    BASE_LEAK_RATE: 0.0005,
    // Multiplier for total player speed -> energy gain
    GAIN_SCALAR: 0.002,
    // Exponential pressure coefficient (resistance increases as tank fills)
    PRESSURE_COEFFICIENT: 0.01,
    // Activity bonus: rewards bursts of engagement from smaller groups
    // (10 active players get 1.6x efficiency vs 5 active players at 1.3x)
    ACTIVITY_BONUS_MULTIPLIER: 1.5,

    // ===== UI: Feedback Cooldowns =====
    // Minimum time between encouragement messages (prevents flicker)
    ENCOURAGEMENT_COOLDOWN: 2000, // ms
};

/**
 * Break-Even Calculations (Reference):
 * 
 * At 50% tank with 10 active players:
 * - Activity Multiplier = 1 + (10/25)*1.5 = 1.6
 * - Pressure Leak = (0.5^3) * 0.01 = 0.00125
 * - Total Leak = 0.0005 + 0.00125 = 0.00175
 * - Required Gain = 0.00175
 * - Required Total Speed = 0.00175 / (0.002 * 1.6) = 0.547
 * - Per Active Player = 0.055 (5.5% average speed)
 * 
 * At 90% tank with 15 active players:
 * - Activity Multiplier = 1.9
 * - Pressure Leak = (0.9^3) * 0.01 = 0.00729
 * - Total Leak = 0.0005 + 0.00729 = 0.00779
 * - Required Total Speed = 0.00779 / (0.002 * 1.9) = 2.05
 * - Per Active Player = 0.137 (13.7% - challenging but achievable!)
 */
